function checked(givenValue) {
  return Boolean(givenValue);
}
export {
  checked
};
//# sourceMappingURL=checked.js.map
